/**
 * ⭐ Board 2814 M2 (the M1 wave's code-review Low) - THE DUPLICATE GUARD'S ONE
 * SENTENCE (plan DD-4), every same-day match named by its reference, else `#id`.
 *
 * ⛔ ONE COPY FOR BOTH SIDES. The crossing route words its 409 with it
 * (`server/app.ts`) and the Requests screen words the confirm step with it
 * (`client/lib/actions.ts` `maybeDuplicateText`), so the two cannot drift; before
 * M2 each side carried its own copy of the same template. `src/shared` is the one
 * directory both bundles import, so it depends on neither side's types.
 */
export function maybeDuplicateSentence(
  matches: ReadonlyArray<{ bookingId: number; jobRef: string | null; likely?: boolean }>,
): string {
  // ⭐ board 2814 M4 fix round 1 (plan DD-4, "marked likely"): the cash half's likely
  // matches (the home's eircode or name on a stop) are already listed first by the
  // server; here each is MARKED in words. A closed boolean, never a name or a place.
  const refs = matches.map((m) => `${m.jobRef ?? `#${String(m.bookingId)}`}${m.likely === true ? ' (likely the same trip)' : ''}`);
  const named = refs.length === 1
    ? `Booking ${refs[0]!}`
    : `Bookings ${refs.slice(0, -1).join(', ')} and ${refs[refs.length - 1]!}`;
  return `${named} on this day may already be this trip. If it is, there is nothing to do. If it is a different trip, press Book it anyway.`;
}
